<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5>
                Hard At Work
            </h5>
        </div>
        
        <ul class="list-group">
            <li v-for="user in shared.online" class="list-group-item">
                <router-link :to="'/users/' + user.id">
                    {{ user.full_name }}
                </router-link>

                <span class="label label-success">
                    Online
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
    import store from '@/store'
    
    export default {
        data() {
            return {
                shared: store
            }
        }
    }
</script>
